import { Model } from '@vuex-orm/core';
import Option from '@/models/Option';
import Projectable from '@/models/Projectable';
import Residence from '@/models/Residence';
import Selector from '@/models/Selector';

export default class Project extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'projects';

  // List of all fields (schema) of the project model.
  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      // relationships
      options: this.morphedByMany(
        Option,
        Projectable,
        'project_id',
        'projectable_id',
        'projectable_type'
      ),
      residences: this.morphedByMany(
        Residence,
        Projectable,
        'project_id',
        'projectable_id',
        'projectable_type'
      ),
      selectors: this.morphedByMany(
        Selector,
        Projectable,
        'project_id',
        'projectable_id',
        'projectable_type'
      ),
    };
  }

  static transformer(item) {
    const project = {};
      project.id = item.id;
      project.name = item.name;
      project.slug = item.slug;
      project.count = item.count;
      project.description = item.description;

    return project;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL, projectId) {
    let url = '/wp-json/wp/v2/project';
    if (projectId) {
      url = `${url}/${projectId}`;
    }
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
